/**
 * @fileoverview DELETE handler for the "/apps/:app_group_id/custom_attributes_settings" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsAppGroupIdCustomAttributesSettingsCacheKeys } from "./constants";
import type {
  DeleteAppsAppGroupIdCustomAttributesSettingsProps,
  AppsAppGroupIdCustomAttributesSettingsResult,
} from "./types";

export const deleteAppsAppGroupIdCustomAttributesSettings = reactQueryMutationAdapter(
  appsAppGroupIdCustomAttributesSettingsCacheKeys,
  (
    props: DeleteAppsAppGroupIdCustomAttributesSettingsProps
  ): Promise<AppsAppGroupIdCustomAttributesSettingsResult> => {
    return fetch(`/apps/${props.appGroupId}/custom_attributes_settings`, "DELETE", props);
  }
);
